import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var TrimPipe = (function () {
    function TrimPipe() {
    }
    TrimPipe.prototype.transform = function (text, chars) {
        if (chars === void 0) { chars = '\\s'; }
        return isString(text) ? text.replace(new RegExp("^[" + chars + "]+|[" + chars + "]+$", 'g'), '') : text;
    };
    return TrimPipe;
}());
export { TrimPipe };
TrimPipe.decorators = [
    { type: Pipe, args: [{ name: 'trim' },] },
];
/** @nocollapse */
TrimPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=trim.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/trim.js
// module id = 270
// module chunks = 4